import { BaseModel } from "sjs-base-model";

export default class DocumentsActionModel extends BaseModel {
    public readonly documentName: string = "";
    public readonly documentCode: string = "";
    public readonly documentDescription: string = "";
    public readonly documentType: number = 0;
    public readonly fileId: string = "";
    public readonly fileName: string = "";
    public readonly printDossierCode: string = "";
    public readonly printCode: number = 0;

    constructor(data: Partial<DocumentsActionModel>) {
        super();

        this.update(data);
    }
}